import { useState } from "react";
import { Button, Form, Input, Card, message, Flex } from "antd";
import axios from "axios";
import "../styles/LoginPage.css";
import { ENDPOINTS } from "../constants/api";

const LoginPage = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = async (e) => {
    try {
      const response = await axios.post(
        ENDPOINTS.LOGIN,
        {},
        {
          auth: {
            username,
            password,
          },
        }
      );
      if (response.data.token) {
        const expiryDate = new Date();
        expiryDate.setHours(expiryDate.getHours() + 10);
        var token = response.data.token;
        localStorage.setItem(
          "authToken",
          JSON.stringify({
            token: token,
            expiryDate: expiryDate.toUTCString(),
          })
        );
        localStorage.setItem("dealer_code", response.data.dealer_code);
        localStorage.setItem("dealer_name", response.data.dealer_name);
        message.success("Login Successful");

        setTimeout(async () => {
          await onLoginSuccess();
        }, 2000);
      } else {
        message.error("Login Failed");
      }
    } catch (error) {
      console.error(error);
      message.error("Login Failed");
    }
  };

  return (
    <div className="login-page-container">
      <Flex
        justify="flex-start"
        align="middle"
        className="login-content"
        flexDirection="column"
      >
        <div className="logo-container">
          <img src="./logo.svg" alt="MGSelect Logo" className="login-logo" />
        </div>
        <Card title="Login: Customer Visit Tracker" className="login-card">
          <Form layout="vertical" onFinish={handleSubmit}>
            <Form.Item label="Username" name="username">
              <Input
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="username"
              />
            </Form.Item>
            <Form.Item label="Password" name="password">
              <Input.Password
                value={password}
                autoComplete="current-password"
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Item>
            <Button type="primary" htmlType="submit" className="long-button">
              Log In
            </Button>
          </Form>
        </Card>
      </Flex>
    </div>
  );
};

export default LoginPage;
